import React from "react";
import { connect } from "react-redux";
import { updateNavigationMenu } from "./../actions/navigationMenuActions";
import styles from "../../../assets/css/modules/navigation/hamburger-menu-button.css";

export const HamburgerMenuButton = ({
  isHamburgerMenuOpen,
  updateNavigationMenu
}) => (
  <button
    className={
      styles.hamburgerOpenToggler +
      " navbar-toggler header-burger hidden-lg-up pt-2 pl-4 mt-4" +
      (isHamburgerMenuOpen ? "" : " collapsed")
    }
    aria-controls="navbarNavAltMarkup"
    aria-label="Toggle navigation"
    aria-expanded={isHamburgerMenuOpen}
    onClick={() => {
      updateNavigationMenu({
        isHamburgerMenuOpen: !isHamburgerMenuOpen
      });
    }}
  >
    <span className="header-burger-line" />
  </button>
);

export const mapStateToHamburgerMenuButton = ({ navigationMenuReducer }) => {
  return {
    isHamburgerMenuOpen: navigationMenuReducer.isHamburgerMenuOpen
  };
};

export default connect(mapStateToHamburgerMenuButton, { updateNavigationMenu })(
  HamburgerMenuButton
);
